export default "__VITE_ASSET__Ct$rgdvy__"